import React from "react";
import styled from "styled-components";
import isMobile from "ismobilejs";

const Wrapper = styled.div`
  width: ${(props) => props.width || "auto"};
  height: ${(props) => props.height || "auto"};
  margin-top: ${(props) => props.top || 0};
  margin-bottom: ${(props) => props.bottom};
`;

/**
 * Spacer component for creating vertical rhythm or sized boxes
 * @param {string} bottom - Bottom margin (backward compatibility)
 * @param {string} top - Top margin (default: 0)
 * @param {string} width - Width of the spacer box
 * @param {string} height - Height of the spacer box
 * @param {string} as - HTML tag to render as (default: "div")
 */
export default function Spacer({ bottom, top = 0, width, height, as = "div", ...props }) {
  // Maintain backward compatibility with existing usage
  const bottomMargin = bottom ? bottom : isMobile().phone ? "50px" : "150px";
  
  return (
    <Wrapper
      as={as}
      bottom={bottomMargin}
      top={top}
      width={width}
      height={height}
      {...props}
    />
  );
}
